// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import AppContext from '../app-context';
import ThemeSwitcher from './theme-switcher';
import styles from './header.scss';
export default function Header({ sticky }) {
    const { mode } = useContext(AppContext);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { id: "h", className: clsx(styles.header, sticky && styles['header-sticky']) },
            React.createElement(Link, { to: `/${mode}/` }, "Demo Assets"),
            React.createElement(ThemeSwitcher, null))));
}
